angular.module('mobilezuz')
	.controller('AppFooter', ['$state', '$rootScope', 'Api', 'BarcodeScaner', 'mDesign', 'Offers', 'Util',
		function($state, $rootScope, Api, BarcodeScaner, mDesign, Offers, Util) {
			var footerCtrl = this,
				_specialCategories = [];

			footerCtrl.scanBarcode = scanBarcode;
			footerCtrl.goToSales = goToSales;
			footerCtrl.fireEvent = fireEvent;
            footerCtrl.icons = {
            	'app.home': 'home',
                'app.specials': 'specials',
                'app.specialCategories': 'specials',
                'app.specials.special': 'specials',
                'app.categories': 'products',
                'app.ordersHistory': 'orders',
				'scan': 'scan',
				'app.cart': 'cart',
				'app.recentPurchases': 'recentPurchases'
			};

			function scanBarcode() {
				return BarcodeScaner.scan().then(function(barcode) {
					if (!barcode) return;

					var query = {
						size: 1,
						from: 0,
						minScore: 0,
						barcode: barcode,
						filters: {
							must: {
								exists: ['family.id', 'family.categoriesPaths.id', 'branch.regularPrice'],
								term: {
									'branch.isActive': true,
									'branch.isVisible': true
								}
							},
							mustNot: {
								term: {
									'branch.regularPrice': 0
								}
							}
						}
					};

					return Api.request({
						method: 'GET',
						url: '/v2/retailers/:rid/branches/:bid/products',
						params: query
					});
				}).then(function(respond) {
					if (!respond) {
						return;
					} else if (!respond.products.length) {
						return mDesign.alert('Sorry. We couldn\'t find this product', function() {
							scanBarcode();
						});
					}

					return Util.goToProductDialog(respond.products[0]);
				});
			}

			function goToSales() {
				if (!_specialCategories) return;

				if (_specialCategories.length) {
					return $state.go('app.specialCategories');
				}

				$state.go('app.specials');
			}

			function _markIcon(toRoute) {
				if(toRoute && toRoute.name) {
                    footerCtrl.markedIcon = footerCtrl.icons[toRoute.name] || '';
				}
			}

			function fireEvent(eventName) {
				$rootScope.$emit(eventName);
			}

            $rootScope.$on('$stateChangeStart', function(event, toRoute) {
                _markIcon(toRoute);
            });

			Offers.getFirstSpecials().then(function(specials) {
				footerCtrl.specials = specials;
			});
		}]);
